var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTypescript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_748_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 27.2612 49.7 29.453 49.1367 31.5367C47.8204 36.4092 45.0684 40.6918 41.3612 43.903C36.9766 47.702 31.2571 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25Z",
    fill: "#0078CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1366 31.5367C47.8203 36.4092 45.0683 40.6918 41.3611 43.903C40.9989 43.9225 40.6203 43.9317 40.2274 43.9317C35.0366 43.9317 32.152 40.6878 30.7183 38.2541L35.4244 35.4266C35.4244 35.4266 37.0254 38.8286 40.0265 38.8286C43.0285 38.8286 44.2295 37.8277 44.2295 35.5266C44.2295 32.7245 34.5233 31.7245 33.0224 26.9215C31.5214 22.1185 33.5224 15.3133 40.5274 15.8144C44.905 16.1266 47.3673 18.2766 48.5988 19.8449L43.9294 23.2184C42.9284 20.3174 38.8264 20.3174 38.0253 22.7184C37.2253 25.1204 39.9263 26.5204 44.1294 27.9214C46.2887 28.6408 48.0254 29.9684 49.1366 31.5367Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3889 16.5807H8.11572V21.6018H15.9115V43.4033H21.5932V21.6018H29.3889V16.5807Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_748_1179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypescript);
export default __webpack_public_path__ + "static/media/icon_typescript.6875c0ac97193630f1d96400b4ecc65d.svg";
export { ForwardRef as ReactComponent };